import React from 'react';
import tw from 'twin.macro';
import { useFilter } from '../utils/hooks/use-filter';

const btnStyles = tw`py-1 px-4 border border-white rounded-full`;
const activeStyles = tw`bg-white text-blue-dark`;

const Filter = ({ posts }) => {
  const { activeFilters, clearFilters, filterButtons, onClickFilter } = useFilter();

  return (
    <div tw="w-full flex flex-wrap gap-2 mb-6">
      <button onClick={clearFilters} css={[btnStyles, activeFilters.length === 0 && activeStyles]}>
        Show all
      </button>
      {filterButtons?.map((label) => (
        <button
          onClick={() => onClickFilter(label)}
          css={[btnStyles, activeFilters.includes(label) && activeStyles]}
          key={label}
        >
          {label}
        </button>
      ))}
    </div>
  );
};

export default Filter;
